//@ts-nocheck
import { useQuery } from 'react-query';

import { axios } from 'lib/axios';

const getNutsCodes = async () => {
  const { data } = await axios.get(`/api/nuts_codes`);

  return data;
};

export const useNutsCodes = () => {

  return useQuery('nutsCodes',
    () => getNutsCodes(), {
    select: ({ data: nutsCodes }) => ({ nutsCodes }),
    initialData: {
      nutsCodes: [],
    },
  });
};